export interface IErrors {
  [key: string]: string;
}

export default function parseApiErrors(err: Record<string, string[]>): IErrors {
  const validationErrors: IErrors = {};

  Object.keys(err).forEach(key => {
    validationErrors[key] = err[key].join(' | ');
  });

  return validationErrors;
}
